module.exports = __webpack_public_path__ + "static/media/icon-sieste.8c7d696f.svg";